import config from "@core/config";
import { storageKeys } from "@core/constants";

export default class MockAuthService {
  static get isEnabled(): boolean {
    return String(config.AZURE_BYPASS_ENABLED).toLowerCase() === "true";
  }

  static get isAuthorized(): boolean {
    return (
      !!localStorage.getItem(storageKeys.mockLogin) ||
      !!localStorage.getItem(storageKeys.mockPassword)
    );
  }

  static login(login: string, password: string): void {
    localStorage.setItem(storageKeys.mockLogin, login);
    localStorage.setItem(storageKeys.mockPassword, password);
  }

  static getLogin(): string | null {
    return localStorage.getItem(storageKeys.mockLogin);
  }

  static getPassword(): string | null {
    return localStorage.getItem(storageKeys.mockPassword);
  }

  static logout(): void {
    localStorage.removeItem(storageKeys.mockLogin);
    localStorage.removeItem(storageKeys.mockPassword);
    window.location.replace(window.location.origin);
  }
}
